import { MessageCircle } from 'lucide-react';

const FloatingButton = ({ 
  agent, 
  onClick, 
  primaryColor,
  tooltipMessage = null, // null por padrão, não renderiza se for null
  tooltipPosition = 'left', // 'top', 'bottom', 'left', 'right'
  tooltipTextColor = '#FFFFFF' // cor do texto por padrão
}) => {
  
  const renderTooltip = tooltipMessage !== null && tooltipMessage !== undefined && tooltipMessage !== '';
  
  const getButtonPositionStyles = () => {
  if (renderTooltip && tooltipPosition === 'bottom') {
    // Se tooltip está em baixo, botão precisa estar mais em cima no container
    return { 
      bottom: 'auto',
      top: '8px', 
      right: '20px' 
    };
  }
  
  if (renderTooltip && tooltipPosition === 'top') {
    // Se tooltip está em cima, botão fica mais embaixo
    return { 
      bottom: '8px', 
      right: '20px' 
    };
  }
  
  return { 
    bottom: '8px', 
    right: '20px' 
  };
};
  
  const getTooltipPositionStyles = () => {
    const positions = {
      top: {
        bottom: 'calc(100% + 8px)',
        left: '50%',
        transform: 'translateX(-50%)'
      },
      bottom: {
        top: 'calc(100% + 8px)',
        left: '50%',
        transform: 'translateX(-50%)'
      },
      left: {
        right: 'calc(100% + 8px)',
        top: '50%',
        transform: 'translateY(-50%)'
      }
    };
    
    return positions[tooltipPosition] || positions.left;
  };

  const getArrowStyles = () => {
    const arrows = {
      top: {
        top: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderTop: `6px solid white`
      },
      bottom: {
        bottom: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderBottom: `6px solid white`
      },
      left: {
        left: '100%',
        top: '50%',
        transform: 'translateY(-50%)',
        borderTop: '6px solid transparent',
        borderBottom: '6px solid transparent',
        borderLeft: `6px solid white`
      }
    };
    
    return arrows[tooltipPosition] || arrows.left;
  };

  return (
    <div 
      className="absolute" 
      style={getButtonPositionStyles()}
    >
      <div className="relative" style={{ overflow: 'visible' }}> {/* Adicione overflow visible */}
        <button
          onClick={onClick}
          className="group relative w-20 h-20 rounded-full hover:shadow-3xl transition-all transform hover:scale-110 overflow-hidden"
          style={{ backgroundColor: primaryColor }}
        >
          <div className="w-full h-full flex items-center justify-center">
            {agent?.widget_settings?.logo_url ? (
              <img 
                src={agent.widget_settings.logo_url} 
                alt={agent.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <MessageCircle className="w-10 h-10 text-white" />
            )}
          </div>
        </button>
        
        {/* Tooltip condicional */}
       {renderTooltip && (
            <div
              className="absolute pointer-events-none"
              style={{
                ...getTooltipPositionStyles(),
                color: "white",
                fontSize: '14px',
                fontWeight: '600',
                zIndex: 10,
                padding: '8px 12px',
                borderRadius: '8px',
                minWidth: '120px',
                maxWidth: tooltipPosition === 'top' || tooltipPosition === 'bottom' ? '200px' : '280px',
                maxHeight: '80px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                lineHeight: '1.4',
                textShadow: '0.5px 0.5px 3px rgba(0, 0, 0, 0.25), 0px 0px 1px rgba(0, 0, 0, 0.6)',
              }}
            >
              {tooltipMessage}
              <div
                className="absolute w-0 h-0"
                style={{
                  ...getArrowStyles(),
                  filter: 'drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.1))'
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
};

export default FloatingButton;